var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Button', {
    on: {
      "click": function ($event) {
        return _vm.$router.push('/home/sac');
      }
    }
  }, [_vm._v("返回")]), _c('h1', [_vm._v(_vm._s(_vm.sacDetail.name))])], 1), _c('Tabs', {
    attrs: {
      "value": _vm.currentTab,
      "animated": false,
      "type": "card"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "生产订单",
      "name": "prodOrder"
    }
  }, [_vm._v("生产订单")]), _c('TabPane', {
    attrs: {
      "label": "客户与配方",
      "name": "customer"
    }
  }, [_c('SACDetailCustomer', {
    ref: "SACDetail_Customer",
    attrs: {
      "sac": _vm.sacDetail
    },
    on: {
      "updateSacFromComponent": _vm.updateSacFromComponent
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": "材料",
      "name": "material"
    }
  }, [_c('SACDetailMaterial', {
    ref: "SACDetail_Material",
    attrs: {
      "sac": _vm.sacDetail
    },
    on: {
      "updateSacFromComponent": _vm.updateSacFromComponent
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }